import React from 'react';
import { makeStyles } from '@mui/styles';
import { CustomInputText } from '../../CustomInputText';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { Grid } from '@mui/material';

export const ReadResponseForm = (props) => {

    const { data } = props;
    const classes = useStyles();

    return (
        <div className={ classes.main }>
             <div className={ classes.container }>
                {
                    data?.cliente && (
                        <Grid container>
                            <Grid item xs>
                                <CustomInputText
                                    label="Cliente"
                                    value={ convertirLetraMayus(data?.cliente?.nombre, true) }
                                />
                            </Grid>

                            <Grid container spacing={2} justifyContent='space-between'>
                                <Grid item xs={ 6 }>
                                    <CustomInputText
                                        label="Correo"
                                        placeholder=''
                                        value={ data?.cliente?.email }
                                    />
                                </Grid>

                                <Grid item xs={ 6 }>
                                    <CustomInputText
                                        label="Celular"
                                        value={ data?.cliente?.celular }
                                    />
                                </Grid>
                            </Grid>
                            
                        </Grid>
                    )
                }

                <ListQuestions questions={ data?.preguntas } />
             </div>
        </div>
    )
}

const ListQuestions = (props) => {

    const { questions } = props;

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 10, marginBottom: 15 }}>
            <label style={{ fontWeight: 600, fontSize: 14 }}>Preguntas</label>

            {
                questions?.map((q, i) => (
                    <div key={ String(i) } style={{ display: 'flex', flexFlow: 'column noWrap', gap: 0, border: '1px solid #bdbdbd', borderRadius: 4, padding: 10, marginBottom: 10 }}>
                        <div>
                            <span style={{ fontWeight: 600, fontSize: 14, marginRight: 5 }}>{`${ i + 1 }.`}</span>
                            <span style={{ fontWeight: 500, fontSize: 14 }}>{ convertirLetraMayus(q?.pregunta) }</span>
                        </div>
                        <div style={{ marginLeft: 16, marginTop: 5 }}>
                            <span style={{ fontWeight: 600, marginRight: 5, fontSize: 14 }}>Respuesta:</span>
                            <span style={{ fontWeight: 500, fontSize: 14 }}>{ convertirLetraMayus(q?.respuesta) }</span>
                        </div>
                    </div>
                ))
            }
        </div>
    )

}

const useStyles =  makeStyles({
    main: {
        position: 'relative',  
        width: 500
    },
    container: {
        padding: 20,
        maxHeight: 700, overflowY: 'scroll'
    }
});